/**
 * This can be used with a tagged template literal in order to provide
 * syntax highlighting for a GraphQL query or mutation.
 */
const gql = String.raw

export default gql
